import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import config from "../../config";

const fetchDocType = (docType, txt, filters, fields) => {
    const params = {
        txt: txt,
        doctype: docType,
        filters: JSON.stringify(filters),
        fields: JSON.stringify(fields),
        limit_start: 0,
        limit_page_length: 150,
    };
    return axios.get(`method/frappe.client.get_list`, { params });
};

const searchDocType = (docType, referenceDoctype, txt, filters) => {
    const params = {
        txt: txt,
        doctype: docType,
        ignore_user_permissions: 0,
        reference_doctype: referenceDoctype,
        filters: JSON.stringify(filters),
    };
    return axios.get(`method/frappe.desk.search.search_link`, { params });
};

export const useListDocTypes = (
    queryIdentifier,
    docType,
    txt,
    filters,
    fields,
    onSuccess,
    onError
) => {
    return useQuery(
        [queryIdentifier],
        async () => {
            const { data } = await fetchDocType(docType, txt, filters, fields);
            return data.message;
        },
        {
            onSuccess,
            onError,
        }
    );
};

export const useSearchDocTypesDependant = (
    docType,
    referenceDoctype,
    txt,
    filters,
    onSuccess,
    onError
) => {
    return useQuery(
        [docType + referenceDoctype],
        async () => {
            const { data } = await searchDocType(
                docType,
                referenceDoctype,
                txt,
                filters
            );
            return data.results;
        },
        {
            onSuccess,
            onError,
            enabled: !!docType && !!referenceDoctype,
        }
    );
};

const validateDoctype = (docType, docname, fields) => {
    const params = {
        doctype: docType,
        docname: docname,
        fields: JSON.stringify(fields),
    };
    return axios.get(`method/${config.request_doctype_validate_method}`, {
        params,
    });
};

export const useValidateDoctype = (
    docType,
    docname,
    fields,
    onSuccess,
    onError
) => {
    return useQuery(
        [docType + docname + "_validation"],
        async () => {
            const { data } = await validateDoctype(docType, docname, fields);
            return data.message;
        },
        {
            onSuccess,
            onError,
            refetchOnWindowFocus: false,
            refetchOnmount: true,
            refetchOnReconnect: false,
            enabled: false,
        }
    );
};
